import { useSupabaseLoader } from "../../../server/supabase/hooks";

/**
 * How many insights the most recent batch produced. Insights are generated in batches that share
 * a `created_at`, which is how the Insights page groups them too.
 */
export function useLatestInsightsBatchCount(
  enabled: boolean,
): ReturnType<typeof useSupabaseLoader<number>> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      if (!enabled) return 0;

      const { data: latest, error } = await supabase
        .from("communication_insights_page")
        .select("created_at")
        .eq("account_id", account_id)
        .order("created_at", { ascending: false })
        .limit(1)
        .maybeSingle();
      if (error) throw error;
      if (!latest) return 0;

      const { count, error: countError } = await supabase
        .from("communication_insights_page")
        .select("id", { count: "exact", head: true })
        .eq("account_id", account_id)
        .eq("created_at", latest.created_at);
      if (countError) throw countError;

      return count ?? 0;
    },
    [enabled],
  );
}
